import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Recording = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Recording</Text>
      <Text style={styles.listItem}>
        This Agreement will not be recorded in the Office of the Recorder of
        Deeds or in any other office or place of public record. If Buyer causes
        or permits this Agreement to be recorded, Seller may elect to treat such
        act as a default of this Agreement.
      </Text>
    </View>
  );
};

export default Recording;
